import { useState } from 'react';
import { getGoogleOAuthUrl, getAppleOAuthUrl } from '../lib/auth-api';

export default function OAuthButtons() {
  const redirectUri = `${window.location.origin}/auth/callback`;
  const [error, setError] = useState<string | null>(null);

  const describeError = (provider: 'Google' | 'Apple', err: unknown): string => {
    if (err instanceof TypeError) {
      return 'Impossible de contacter le serveur. Vérifiez votre connexion.';
    }
    if (err instanceof Error && err.message) {
      return `${provider}: ${err.message}`;
    }
    return `${provider} indisponible. Réessayez plus tard.`;
  };

  const handleGoogle = async () => {
    setError(null);
    try {
      const url = await getGoogleOAuthUrl(redirectUri);
      window.location.href = url;
    } catch (err) {
      console.error('Google OAuth init failed:', err);
      setError(describeError('Google', err));
    }
  };

  const handleApple = async () => {
    setError(null);
    try {
      const url = await getAppleOAuthUrl(redirectUri);
      window.location.href = url;
    } catch (err) {
      console.error('Apple OAuth init failed:', err);
      setError(describeError('Apple', err));
    }
  };

  return (
    <div className="space-y-3">
      {error && (
        <div role="alert" className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
          {error}
        </div>
      )}
      <div className="relative my-4">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-gray-300" />
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="bg-white px-3 text-gray-500">ou</span>
        </div>
      </div>

      <button
        type="button"
        onClick={handleGoogle}
        className="w-full flex items-center justify-center gap-3 px-4 py-2 border border-gray-300 rounded-lg bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
      >
        <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
          <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" />
          <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
          <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18A10.96 10.96 0 0 0 1 12c0 1.77.42 3.45 1.18 4.93l3.66-2.84z" />
          <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
        </svg>
        Continuer avec Google
      </button>

      <button
        type="button"
        onClick={handleApple}
        className="w-full flex items-center justify-center gap-3 px-4 py-2 rounded-lg bg-black text-white text-sm font-medium hover:bg-gray-900 transition-colors"
      >
        <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
          <path d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.48-3.24 0-1.44.62-2.2.44-3.06-.4C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
        </svg>
        Continuer avec Apple
      </button>
    </div>
  );
}
